import React from 'react'

export default props => (
  <svg viewBox="0 0 511.99 511.99" {...props}>
    <g>
      <g>
        <path d="M470.238,31.479H41.762C18.735,31.479,0,50.214,0,73.242v250.53c0,23.029,18.735,41.764,41.763,41.764h24.415v103.079                 c0,4.816,2.902,9.157,7.35,11c1.473,0.61,3.019,0.906,4.553,0.906c3.099,0,6.145-1.21,8.422-3.487L198,365.535h272.236                 c23.028,0,41.762-18.735,41.762-41.764V73.242C512,50.214,493.265,31.479,470.238,31.479z M470.238,341.722H193.062                 c-3.08,0-5.878,1.18-7.991,3.099c-0.019,0.017-0.041,0.038-0.06,0.055c-0.145,0.133-0.293,0.263-0.431,0.404L89.99,439.869                 v-86.241c0-0.414-0.021-0.781-0.063-1.105c-0.558-6.057-5.647-10.801-11.85-10.801H41.762c-9.898,0-17.95-8.053-17.95-17.951                 V73.242c0-9.898,8.052-17.95,17.95-17.95h428.475c9.899,0,17.95,8.052,17.95,17.95v250.53h0                 C488.187,333.669,480.135,341.722,470.238,341.722z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M173.987,118.437h-69.399c-6.576,0-11.906,5.332-11.906,11.906c0,6.575,5.33,11.906,11.906,11.906h69.399                 c6.576,0,11.906-5.332,11.906-11.906C185.893,123.768,180.562,118.437,173.987,118.437z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M297.738,186.6H104.587c-6.576,0-11.906,5.332-11.906,11.906c0,6.575,5.33,11.906,11.906,11.906h193.151                 c6.575,0,11.906-5.33,11.906-11.906C309.644,191.932,304.313,186.6,297.738,186.6z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M407.414,118.437H243.507c-6.576,0-11.906,5.332-11.906,11.906c0,6.575,5.33,11.906,11.906,11.906h163.907                 c6.575,0,11.906-5.332,11.906-11.906C419.32,123.767,413.989,118.437,407.414,118.437z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M407.414,186.6h-43.102c-6.575,0-11.906,5.332-11.906,11.906c0,6.576,5.332,11.906,11.906,11.906h43.102                 c6.575,0,11.906-5.33,11.906-11.906C419.32,191.93,413.989,186.6,407.414,186.6z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M212.407,254.765h-107.82c-6.576,0-11.906,5.33-11.906,11.906c0,6.575,5.33,11.906,11.906,11.906h107.82                 c6.576,0,11.906-5.332,11.906-11.906C224.313,260.095,218.983,254.765,212.407,254.765z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M407.414,254.765H275.675c-6.575,0-11.906,5.33-11.906,11.906c0,6.575,5.332,11.906,11.906,11.906h131.739                 c6.575,0,11.906-5.332,11.906-11.906C419.32,260.095,413.989,254.765,407.414,254.765z" />
      </g>
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/Assets/Images/icons/chat.js